module.exports = __webpack_public_path__ + "3169b3c10f3375279c7349efa780e46e.svg";